import Vue from 'vue';

const sendMsg = (message, type, title = undefined, confirmFunction = undefined, cancelFunction = undefined) => {
    Vue.prototype.$confirm(message, title, {
        type: type,
        dangerouslyUseHTMLString: true
    }).then(() => {
        if (confirmFunction !== undefined) {
            confirmFunction();
        }
    }).catch(() => {
        if (cancelFunction !== undefined) {
            cancelFunction();
        }
    });
};

class Confirm {
    success(message, title, confirmFunction, cancelFunction) {
        sendMsg(message, 'success', title, confirmFunction, cancelFunction);
    }

    warning(message, title, confirmFunction, cancelFunction) {
        sendMsg(message, 'warning', title, confirmFunction, cancelFunction);
    }

    info(message, title, confirmFunction, cancelFunction) {
        sendMsg(message, 'info', title, confirmFunction, cancelFunction);
    }

    error(message, title, confirmFunction, cancelFunction) {
        sendMsg(message, 'error', title, confirmFunction, cancelFunction);
    }
}

export const confirm = new Confirm();
